<div id="top-of-page"></div>
<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<div class="d-flex justify-content-between align-items-center mt-3 ms-1 mb-3 w-100">
  <div>
    <h3 class="m-0">Nuova {{ getDocumentTypeName(newInvoice.document_type!) }}</h3>
    <p class="m-0 text-muted">Clicca su una scheda per espanderne il contenuto</p>
  </div>

  <div class="hidden-mobile">
    <button
      mat-stroked-button
      type="button"
      (click)="openGuide2Dialog()"
      matTooltip="Vedi guida alla fatturazione"
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
      class="izy-button-ghost custom-button-border"
    >
      <mat-icon>help</mat-icon>
      Guida alla fatturazione
    </button>
  </div>
</div>

<!-- mobile version -->
<div class="visible-mobile mt-2 w-100 mb-3">
  <button
    mat-stroked-button
    type="button"
    (click)="openGuide2Dialog()"
    matTooltip="Vedi guida alla fatturazione"
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    class="w-100 izy-button-ghost custom-button-border"
  >
    <mat-icon>help</mat-icon>
    Guida alla fatturazione
  </button>
</div>

<!-- Main container for both cards -->
<div class="row mb-3 mb-md-2">
  <!-- First Card -->
  <div class="col-md-6 d-flex flex-column">
    <mat-card class="h-100 d-flex custom-card izy-sharp-bl">
      <mat-card-content class="h-100">
        <h5 class="mb-3">Seleziona cliente</h5>
        
        <!-- Main container-->
        <div class="h-100">
          <!-- Autocomplete with clear button container -->
          <div class="d-flex align-items-center gap-2 w-100">
            <!-- Autocomplete (takes most space) -->
            <div class="w-100">
              <app-company-autocomplete
                #companyAutocomplete
                [myControl]="myControl"
                (optionSelected)="onCompanySelected($event)"
              ></app-company-autocomplete>
            </div>

            <!-- Clear button (fixed width) -->
            <button
              *ngIf="myControl.value"
              mat-icon-button
              color="warn"
              (click)="clearCompanySelection()"
              type="button"
              class="mb-4 flex-shrink-0 custom-button-border"
              matTooltip="Cancella selezione cliente"
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <!-- Button Group -->
          <div class="w-sm-100 h-100">
            <div class="actions d-flex gap-2 w-100">
              <button
                mat-raised-button
                (click)="navigateToNewCompany()"
                class="w-sm-50-mobile-50 primary-button custom-button-border"
                matButton="filled"
                matTooltip="Registra un nuovo cliente."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                <mat-icon>person_add</mat-icon>
                <span>Nuovo</span>
              </button>
              <button
                mat-stroked-button
                (click)="openDialog()"
                class="w-sm-50-mobile-50 custom-button-border"
                matTooltip="Registra un nuovo cliente rapidamente, senza uscire dalla schermata."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                <mat-icon>bolt</mat-icon>
                <span class="hidden-mobile">Aggiunta rapida</span>
                <span class="visible-mobile">Rapido</span>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Second Card (company) - Desktop version -->
  <div class="col-md-6 d-flex flex-column">
    <mat-card class="h-100 mt-md-0 mt-3 custom-card izy-sharp-bl hidden-mobile">
      <mat-card-content class="h-100">
        <h5 class="mb-1">Cliente selezionato</h5>
        <!-- Add your content for the second card here -->
        <div class="d-flex flex-column h-100 justify-content-center">
          <div class="row">
            
            <!-- Show when no company is selected -->
            <div *ngIf="!newInvoice.company?.company_name" class="text-center text-muted py-4">
              <mat-icon class="mb-2">face</mat-icon>
              <p>Nessun cliente selezionato</p>
              <small>Seleziona un cliente dalla barra di ricerca</small>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newInvoice.company?.company_name" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Nome</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.company_name }}
                  </div>
                </div>
              </div>

              <div *ngIf="newInvoice.company?.iva_number" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Partita IVA</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.iva_number }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newInvoice.company?.address" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Indirizzo</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.address }}
                  </div>
                </div>
              </div>

              <div *ngIf="newInvoice.company?.addressee_code" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Codice SDI</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.addressee_code }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Second Card (company) - Desktop version -->
  <div class="col-md-6 d-flex flex-column">
    <mat-expansion-panel
      class="h-100 mt-md-0 mt-3 custom-card izy-sharp-bl visible-mobile"
      #panelclient>
      <!-- <mat-card-content class="h-100"> -->
        <mat-expansion-panel-header>
          <mat-panel-title>
            Cliente
          </mat-panel-title>
          <mat-panel-description>
            {{ newInvoice.company?.company_name ? newInvoice.company?.company_name : 'Nessuno' }}
            <span class="panel-state">{{ panelclient.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!-- <h5 class="mb-3">Cliente selezionato</h5> -->

        <!-- Add your content for the second card here -->
        <div class="d-flex flex-column h-100 justify-content-center">
          <div class="row">
            
            <!-- Show when no company is selected -->
            <div *ngIf="!newInvoice.company?.company_name" class="text-center text-muted py-4">
              <mat-icon class="mb-2">face</mat-icon>
              <p>Nessun cliente selezionato</p>
              <small>Seleziona un cliente dalla barra di ricerca</small>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newInvoice.company?.company_name" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Nome</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.company_name }}
                  </div>
                </div>
              </div>

              <div *ngIf="newInvoice.company?.iva_number" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Partita IVA</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.iva_number }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newInvoice.company?.address" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Indirizzo</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.address }}
                  </div>
                </div>
              </div>

              <div *ngIf="newInvoice.company?.addressee_code" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Codice SDI</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newInvoice.company?.addressee_code }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      <!-- </mat-card-content> -->
    </mat-expansion-panel>
  </div>

</div>

<!-- <mat-card class="mb-3 mb-md-2 col-md-5 d-flex flex-column custom-card">
  <mat-card-content class="h-100">
    <p>Cliente:</p>
    
  </mat-card-content>
</mat-card> -->

<div class="form-container">
  <form #invoiceForm="ngForm" (ngSubmit)="addNewElement()" class="invoice-form">
    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      [expanded]="true"
      #panel
    >

    <mat-expansion-panel-header>
      <mat-panel-title>
        Documento
      </mat-panel-title>
      <mat-panel-description>
        Num. {{ newInvoice.progressive_number ? newInvoice.progressive_number : 'n' }}/{{ newInvoice.enumeration ? newInvoice.enumeration : 'Anno' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

      <!-- <mat-card> -->
        <!-- <h5 class="mb-3">Dati documento</h5> -->

        <!-- <form #documentForm="ngForm" (ngSubmit)="addNewElement()" class="invoice-form"> -->
        <div class="row">
          <!-- <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nome fattura</mat-label>
            <input
              matInput
              [(ngModel)]="newInvoice.invoice_name"
              name="invoice_name"
              required
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Numero progressivo</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newInvoice.progressive_number"
              (ngModelChange)="markAsChanged()"
              name="progressive_number"
              matTooltip="Numero progressivo della fattura. Ricorda che in questo campo la sequenza numerica deve essere progressiva (es. 1, 2, 3...), senza salti o numeri ripetuti. Il 1° gennaio di ogni anno, la numerazione riparte da 1!"
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Numerazione</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newInvoice.enumeration"
              (ngModelChange)="markAsChanged()"
              name="enumeration"
              matTooltip="La numerazione è importante. Ricorda di indicare in questo campo l'anno di riferimento, prestando attenzione all'ultimo numero progressivo già inserito in precedenza."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Valuta</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newInvoice.currency"
              name="currency"
              required
            >
              <mat-option
                *ngFor="let currency of currencyOptions"
                [value]="currency.code"
              >
                {{ currency.code }} - {{ currency.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Lingua</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newInvoice.language"
              name="language"
              required
            >
              <mat-option
                *ngFor="let language of languageOptions"
                [value]="language.code"
              >
                {{ language.name }}
              </mat-option>
            </mat-select>
            <!-- <input
            matInput
            [(ngModel)]="newInvoice.language"
            name="language"
          /> -->
          </mat-form-field>

          <!-- ATECO Code Dropdown -->
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Seleziona Codice ATECO</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newInvoice.ateco_code_id"
              name="ateco_code_id"
              (selectionChange)="onAtecoCodeChange($event)"
              matTooltip="Seleziona il codice ATECO di riferimento fra quelli disponibili."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              [disabled]="isLoading">
              
              <!-- Loading state -->
              <mat-option *ngIf="isLoading" disabled>
                <div style="display: flex; align-items: center;">
                  <mat-spinner diameter="20" style="margin-right: 8px;"></mat-spinner>
                  Caricamento...
                </div>
              </mat-option>
              
              <!-- No codes available -->
              <mat-option *ngIf="!isLoading && atecoCodes.length === 0" disabled>
                Nessun codice ATECO disponibile
              </mat-option>
              
              <!-- ATECO code options -->
              <mat-option 
                *ngFor="let atecoCode of atecoCodes" 
                [value]="atecoCode.id">
                {{ atecoCode.ateco_division }}.{{ atecoCode.ateco_class }}.{{ atecoCode.ateco_subcategory }} - {{ atecoCode.name }}
              </mat-option>
            </mat-select>
            
            <!-- Loading hint -->
            <mat-hint *ngIf="isLoading">Caricamento codici ATECO...</mat-hint>
            <mat-hint *ngIf="!isLoading && atecoCodes.length > 0">
              {{ atecoCodes.length }} codici disponibili
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Descrizione/Oggetto fattura</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="6"
              type="string"
              [(ngModel)]="newInvoice.description"
              name="description"
              matTooltip="Questa è la causale del tuo documento. Indica, sinteticamente, che tipo di prestazione hai effettuato."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            ></textarea>
          </mat-form-field>
          
        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Note (opzionali)</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="6"
              type="string"
              [(ngModel)]="newInvoice.notes"
              name="notes"
              matTooltip="Queste annotazioni appariranno in fondo al documento in PDF."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            ></textarea>
          </mat-form-field>
        
        </div>          

      <!-- </mat-card> -->
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      #panel2
    >
      <!-- <mat-card-content> -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          Fatturazione
        </mat-panel-title>
        <mat-panel-description>
          {{ newInvoice.document_type ? getDocumentTypeName(newInvoice.document_type!) : 'Fattura' }} - {{ newInvoice.emission_date ? formatFormDate(newInvoice.emission_date) : '' }}
          <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

        <!-- <h5 class="mb-3">Fatturazione elettronica</h5> -->
        <!-- <form #invoiceForm="ngForm" (ngSubmit)="addNewElement()" class="invoice-form"> -->

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Tipo documento</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newInvoice.document_type"
              name="document_type"
              matTooltip="Il tipo di documento che stai per generare."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            >
              <mat-option
                *ngFor="let method of documentTypeOptions"
                [value]="method.code"
              >
                {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Metodo di pagamento</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newInvoice.payment_method"
              name="payment_method"
              matTooltip="Qui indichi come preferisci essere pagato/a."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            >
              <mat-option
                *ngFor="let method of paymentMethodOptions"
                [value]="method.code"
              >
                {{ method.code }} - {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>IBAN</mat-label>
            <input matInput [(ngModel)]="newInvoice.iban" name="iban" />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>IBAN</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4"
              [(ngModel)]="newInvoice.iban"
              name="iban"
              (ngModelChange)="validateIban()"
              [pattern]="'^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{11,30}$'"
              matTooltip="Indica un IBAN sul quale desideri ricevere il pagamento, se il metodo di pagamento scekto lo prevede."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            ></textarea>
            <mat-error *ngIf="!isValidIban || newInvoice.iban">
              IBAN non valido. Formato: AA00XXXXXXXXXXXXXXXXXXXXXXX
            </mat-error>
          </mat-form-field>

        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Data di emissione</mat-label>
            <input
              matInput
              [matDatepicker]="emissionDatePicker"
              [(ngModel)]="newInvoice.emission_date"
              name="emission_date"
              matTooltip="La data di emissione della fattura."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
            <!-- (ngModelChange)="onEmissionDateChange($event)" -->
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Termini di pagamento (giorni)</mat-label>
            <input
              matInput
              type="number"
              min="0"
              max="1000"
              [(ngModel)]="newInvoice.payment_days"
              name="payment_days"
              matTooltip="Fra quanti giorni vuoi che il tuo cliente paghi? Qui puoi indicare (in giorni) un intervallo e l'App calcolerà la data di pagamento (prevista) in automatico."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Codice destinatario</mat-label>
            <input
              matInput
              [(ngModel)]="newInvoice.addressee_code"
              name="addresse_code"
              matTooltip="Questo è il codice SDI del tuo cliente. Viene impostato in automatico in base alla tua anagrafica, ma puoi eventualmente modificarlo qui."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
              minlength="6"
              maxlength="7"
              pattern="^[A-Z0-9]*"
              #addresseeCodeInput="ngModel"
            />
            <mat-error *ngIf="addresseeCodeInput.invalid && (addresseeCodeInput.dirty || addresseeCodeInput.touched)">
              Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Nome destinatario</mat-label>
            <input
              matInput
              [(ngModel)]="newInvoice.addressee_name"
              name="addresse_name"
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Esigibilità IVA</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newInvoice.iva_collectability"
              name="iva_collectability"
              required
              disabled
            >
              <mat-option
                *ngFor="let method of ivaCollectabilityOptions"
                [value]="method.code"
              >
                {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <!-- <h6>Dati aggiuntivi:</h6> -->

        <!-- Stessa veste del pannello filtri della tabella fatture: superficie
             bianca bordata nera 2px, angolo basso-sinistro vivo e velo giallo
             (accent-2) in hover sull'header. -->
        <mat-expansion-panel class="mb-2 izy-extra-data-panel izy-sharp-bl">

          <mat-expansion-panel-header>
            <mat-panel-title
              matTooltip="Clicca su questo pannello per espandere la scheda dei campi avanzati della fattura (come CIG, CUP ecc...). Utilizza questi campi se richiesto dal documento che stai per generare."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              <h6>Dati aggiuntivi fattura:</h6>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>ID documento</mat-label>
              <input
                matInput
                [(ngModel)]="newInvoice.document_id"
                name="document_id"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Data documento</mat-label>
              <input
                matInput
                [(ngModel)]="newInvoice.id_document_date"
                name="id_document_date"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Voce documento</mat-label>
              <input
                matInput
                [(ngModel)]="newInvoice.id_document_voice"
                name="id_document_voice"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Codice Comm. Conv.</mat-label>
              <input
                matInput
                [(ngModel)]="newInvoice.cod_comm_conv"
                name="cod_comm_conv"
              />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Codice CIG</mat-label>
              <input
                matInput
                [(ngModel)]="newInvoice.cig"
                name="cig"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Codice CUP</mat-label>
              <input
                matInput
                [(ngModel)]="newInvoice.cup"
                name="cup"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-sm-25">
              <mat-label>Riferimento num. linea</mat-label>
              <input
                matInput
                [(ngModel)]="newInvoice.rif_righe_fatt"
                name="rif_righe_fatt"
              />
            </mat-form-field>
          </div>

        </mat-expansion-panel>

        <div class="row">
          <div class="w-sm-25">
            <mat-slide-toggle
              [(ngModel)]="newInvoice.p_a"
              name="p_a"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onPaToggleChange($event)"
              matTooltip="Fattura per Pubblica Amministrazione."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Pubblica Amministrazione
            </mat-slide-toggle>
          </div>

          <div class="w-sm-25">
            <mat-slide-toggle
              [checked]="revenueStampOption === 'customer'"
              name="revenueStampCustomer"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onRevenueStampCustomerChange($event); detectChanges(); calculateAllTaxWithholdings()"
              matTooltip="Inserisce una marca da bollo a carico del cliente."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Bollo a carico del cliente
            </mat-slide-toggle>
          </div>

          <div class="w-sm-25">
            <mat-slide-toggle
              [checked]="revenueStampOption === 'me'"
              name="revenueStampMe"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onRevenueStampMeChange($event)"
              matTooltip="Inserisce una marca da bollo a tuo carico."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Marca da bollo a tuo carico
            </mat-slide-toggle>
          </div>

          <div class="w-sm-25">
            <mat-slide-toggle
              [(ngModel)]="newInvoice.healthcare_invoice"
              name="healthcare_invoice"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onHealthcareToggleChange($event)"
              matTooltip="Fattura per prestazione sanitaria. Queste fatture non vengono inoltrate allo SDI (sono fatture solo cartacee)."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Fattura prestazione sanitaria
            </mat-slide-toggle>
          </div>

          <!-- <mat-form-field appearance="outline" class="mt-md-0 mt-3 w-sm-25">
            <mat-label>Marca da bollo</mat-label>
            <input
              matInput
              [(ngModel)]="newInvoice.revenue_stamp"
              (ngModelChange)="onRevenueStampChange($event)"
              name="revenue_stamp"
            />
          </mat-form-field> -->
        </div>

        <!-- </form> -->
      <!-- </mat-card-content> -->
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      #panel3
    >
      <!-- <mat-card-content class="d-flex flex-column"> -->
        <mat-expansion-panel-header>
          <mat-panel-title>
            Prestazioni
          </mat-panel-title>
          <mat-panel-description>
            Aggiunte: <span class="article-badge">{{ numero_articoli }}</span>
            <span class="panel-state">{{ panel3.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!-- <h5 #productsList>Prodotti e servizi:</h5> -->

        <!-- List of added products/services -->
        <mat-card
          *ngFor="let item of productServices; let i = index"
          class="mb-2 izy-item-card product-card izy-sharp-bl"
        >
          <mat-card-content>
            <div class="izy-item-card__row">
              <div class="izy-item-card__body">
                <div class="izy-item-card__heading">
                  <span class="izy-item-card__title">{{ item.name }}</span>
                  <span class="izy-item-card__meta">
                    {{ item.quantity }} {{ item.units }}
                  </span>
                </div>
                <div class="izy-item-card__amount">
                  {{ formatCardAmount(item?.final_amount) }}
                  <span class="izy-item-card__amount-note">
                    di cui IVA {{ formatCardAmount(item.iva_amount) }}
                  </span>
                </div>
                <p *ngIf="item.description" class="izy-item-card__description">
                  <i>{{item.description}}</i>
                </p>
              </div>
              <button
                mat-icon-button
                color="warn"
                (click)="removeProductService(i)"
                type="button"
                class="custom-button-border izy-item-card__remove"
                matTooltip="Rimuovi questa voce dalla fattura."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Autocomplete -->
        <div class="mt-3">
          <p>Cerca fra le prestazioni salvate:</p>

          <app-savedproduct-autocomplete
            [productControl]="productControl"
            (optionSelected)="onSavedProductSelected($event)"
          >
          </app-savedproduct-autocomplete>
        </div>

        <!-- Form to add new product/service -->
        <form
          #productServiceForm="ngForm"
          (ngSubmit)="addNewProductService(productServiceForm)"
          class="product-service-form d-flex flex-column"
        >
          <p>Oppure aggiungi un nuovo prodotto/servizio:</p>

          <div class="row">
            <!-- <mat-form-field appearance="outline" class="w-sm-50">
              <mat-label>Descrizione</mat-label>
              <input
                matInput
                [(ngModel)]="newProductService.name"
                name="name"
                required
                (change)="calculateFinalAmount()"
              />
            </mat-form-field> -->

            <mat-form-field appearance="outline" class="w-sm-50">
              <mat-label>Nome voce</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="6"
                [(ngModel)]="newProductService.name"
                name="name"
                required
                #nameInput="ngModel"
                maxlength="1000"
                (ngModelChange)="validateProductDescription(newProductService.name); calculateFinalAmount()"
                (blur)="validateProductDescription(newProductService.name)"
                matTooltip="Il nome della prestazione che vuoi inserire in fattura."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              ></textarea>
              <mat-error *ngIf="nameInput.invalid && nameInput.touched">
                <span *ngIf="nameInput.errors?.['required']">
                  La descrizione è obbligatoria
                </span>
                <span *ngIf="nameInput.errors?.['maxlength']">
                  La descrizione non può superare {{ MAX_DESCRIPTION_LENGTH }} caratteri
                </span>
                <span *ngIf="nameInput.errors?.['latinPattern']">
                  Sono ammessi solo caratteri latini (lettere, numeri, simboli standard e caratteri accentati)
                </span>
              </mat-error>
              <mat-hint *ngIf="newProductService.name">
                {{ newProductService.name.length }}/1000 caratteri
              </mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Quantità</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.quantity"
                name="quantity"
                required
                (change)="calculateFinalAmount()"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Unità di misura</mat-label>
              <input
                matInput
                [(ngModel)]="newProductService.units"
                name="units"
                (change)="calculateFinalAmount()"
              />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Prezzo unitario</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.gross_amount"
                name="gross_amount"
                matTooltip="Prezzo per ogni singola unità. L'App calcolerà il totale in automatico."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
                required
                (change)="calculateFinalAmount()"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Sconto (%):</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.discount"
                name="discount"
                (change)="calculateFinalAmount()"
                matTooltip="Usa questo campo per calcolare in automatico uno sconto percentuale sul totale della prestazione."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>IVA (%):</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.iva_percentage"
                name="iva_percentage"
                (change)="calculateFinalAmount()"
                disabled
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Totale</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.final_amount"
                name="final_amount"
                required
                (change)="calculateFinalAmount()"
                matTooltip="Totale dovuto per questa prestazione (il calcolo viene effettuato in automatico)."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
                readonly
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-50">
              <mat-label>Descrizione (opzionale)</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="6"
                [(ngModel)]="newProductService.description"
                name="description"
                (change)="calculateFinalAmount()"
                matTooltip="Aggiungi una descrizione opzionale, per permettere al tuo cliente di comprendere al meglio cosa stai inserendo in fattura."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              ></textarea>
            </mat-form-field>
          </div>

          <div class="d-flex align-self-end">
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="saveNewProductServiceInSavedList()"
              [disabled]="!productServiceForm.valid"
              matButton="filled"
              class="mt-2 me-2 align-self-end hidden-mobile primary-button custom-button-border"
              matTooltip="Aggiungi questa prestazione all'anagrafica prestazioni'."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
            <mat-icon>bookmark_add</mat-icon>
              Salva prestazione in anagrafica
            </button>
            <!-- mobile version -->
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="saveNewProductServiceInSavedList()"
              [disabled]="!productServiceForm.valid"
              matButton="filled"
              class="mt-2 me-2 align-self-end visible-mobile primary-button custom-button-border"
              matTooltip="Aggiungi questa prestazione all'anagrafica prestazioni'."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
            <mat-icon>bookmark_add</mat-icon>
              Salva
            </button>
            <button
              mat-raised-button
              color="primary"
              type="submit"
              (click)="scrollToProductList()"
              [disabled]="!productServiceForm.valid"
              matButton="filled"
              class="mt-2 align-self-end primary-button custom-button-border"
              matTooltip="Aggiungi questa prestazione al documento."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
            <mat-icon>add_task</mat-icon>
              Aggiungi voce
            </button>
          </div>
        </form>
      <!-- </mat-card-content> -->
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      #panel4
    >
    <!-- <mat-card-content class="d-flex flex-column"> -->
      <mat-expansion-panel-header>
          <mat-panel-title>
            Contributi
          </mat-panel-title>
          <mat-panel-description>
            Aggiunti: <span class="withholding-badge">{{ numero_contributi }}</span>
            <span class="panel-state">{{ panel4.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
      <!-- <h5 #taxwithholdingsList>Contributi e ritenute:</h5> -->

          <!-- List of added tax withholdings -->
          <mat-card
            *ngFor="let item of taxWithholdings; let i = index"
            class="mb-2 izy-item-card taxwithholding-card izy-sharp-bl"
          >
            <mat-card-content>
              <div class="izy-item-card__row">
                <div class="izy-item-card__body">
                  <div class="izy-item-card__heading">
                    <span class="izy-item-card__title">{{ item.kind }}</span>
                    <span class="izy-item-card__meta">
                      {{ item.rate_percentage }}% su {{ item.total_percentage }}%
                    </span>
                  </div>
                  <div class="izy-item-card__amount">
                    {{ formatCardAmount(item.rate_amount) }}
                  </div>
                </div>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="removeTaxWithholding(i)"
                  type="button"
                  class="custom-button-border izy-item-card__remove"
                  matTooltip="Rimuovi questo contributo dalla fattura."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Form to add new tax withholding -->
          <form
            #taxWithholdingForm="ngForm"
            (ngSubmit)="addNewTaxWithholding()"
            class="tax-withholding-form d-flex flex-column"
          >
            <p>Aggiungi contributo o ritenuta:</p>

            <div class="row">
              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Tipo</mat-label>
                <mat-select
                  class="izy-select-trigger"
                  panelClass="izy-select-panel izy-select-panel--form"
                  [(ngModel)]="newTaxWithholding.kind"
                  name="kind"
                  required
                  [disabled]="getAvailableKinds().length === 0"
                  (ngModelChange)="setDefaultRate($event)"
                  matTooltip="La tipologia di voce che sta inserendo. Ricorda che puoi inserire un solo valore per ogni tipo."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
                >
                  <!-- Show warning when all kinds are used -->
                  <mat-option *ngIf="getAvailableKinds().length === 0" disabled>
                    Tutti i tipi sono già stati aggiunti
                  </mat-option>
                  
                  <!-- Show available kinds -->
                  <mat-option
                    *ngFor="let kind of getAvailableKinds()"
                    [value]="kind.code"
                  >
                    {{ kind.name }}
                    <span *ngIf="isKindAlreadyUsed(kind.code)" class="text-muted">
                      (già presente)
                    </span>
                  </mat-option>
                </mat-select>
                
                <!-- Hint about limitations -->
                <mat-hint *ngIf="getAvailableKinds().length > 0">
                  {{ getAvailableKinds().length }} tipi disponibili
                </mat-hint>
                <mat-hint *ngIf="getAvailableKinds().length === 0" class="text-warning">
                  Hai già aggiunto tutti i tipi disponibili
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Percentuale (%)</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="newTaxWithholding.rate_percentage"
                  name="rate_percentage"
                  required
                  (change)="calculateTaxWithholdingTotal()"
                  [disabled]="isKindAlreadyUsed(newTaxWithholding.kind)"
                  matTooltip="La percentuale da calcolare sull'imponibile."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Su imponibile (%)</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="newTaxWithholding.total_percentage"
                  name="total_percentage"
                  required
                  [disabled]="isKindAlreadyUsed(newTaxWithholding.kind)"
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Valore (€)</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="newTaxWithholding.rate_amount"
                  name="rate_amount"
                  matTooltip="Questo valore viene calcolato in automatico in base alle percentuali inserite."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                  required
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="row">            
              <mat-form-field appearance="outline" class="w-sm-50">
                <mat-label>Dettagli (opzionali)</mat-label>
                <textarea
                  matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="6"
                  [(ngModel)]="newTaxWithholding.details"
                  name="details"
                  [disabled]="isKindAlreadyUsed(newTaxWithholding.kind)"
                ></textarea>
              </mat-form-field>

              <!-- Show pension fund only when 'Cassa' is selected -->
              <mat-form-field 
                appearance="outline" 
                class="w-sm-50"
                *ngIf="newTaxWithholding.kind === 'CASSA'"
              >
                <mat-label>Cassa previdenziale</mat-label>
                <mat-select
                  class="izy-select-trigger"
                  panelClass="izy-select-panel izy-select-panel--form"
                  [(ngModel)]="newInvoice.pension_fund_type"
                  name="pension_fund_type"
                  matTooltip="Seleziona la cassa previdenziale di riferimento."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <mat-option
                    *ngFor="let pension_fund of pensionFundOptions"
                    [value]="pension_fund.code"
                  >
                    {{ pension_fund.code }} - {{ pension_fund.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>

            <!-- Warning message -->
            <div *ngIf="isKindAlreadyUsed(newTaxWithholding.kind)" class="alert alert-warning mt-2 d-grid align-items-center" style="grid-template-columns: auto 1fr; gap: 8px;">
              <mat-icon class="me-2">warning</mat-icon>
              Hai già aggiunto una {{ getKindDisplayName(newTaxWithholding.kind) }}. 
              Puoi averne solo una per tipo.
            </div>

            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!taxWithholdingForm.valid || isKindAlreadyUsed(newTaxWithholding.kind)"
              matButton="filled"
              class="mt-2 align-self-end primary-button custom-button-border"
            >
              <mat-icon>post_add</mat-icon>
              Aggiungi contributo/ritenuta
            </button>
          </form>
        <!-- </mat-card-content> -->
      </mat-expansion-panel>

    <mat-card class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl">
      <mat-card-content class="d-flex flex-column">
        <h4 class="m-2">Riepilogo:</h4>
        
        <p 
          class="ms-2 colored-primary-text" 
          *ngIf="newInvoice.healthcare_invoice === true || newInvoice.paper_invoice === true"
        >
          Questa {{ getDocumentTypeName(newInvoice.document_type!) }} sarà solo cartacea. Non verrà emessa come {{ getDocumentTypeName(newInvoice.document_type!) }} Elettronica.
        </p>

        <p class="ms-2 small text-muted" *ngIf="newInvoice.healthcare_invoice === false">{{ newInvoice.document_type }} - {{ getDocumentTypeName(newInvoice.document_type!) }}{{ newInvoice.p_a ? ' PA' : '' }}</p>
        <!-- if healthcare invoice -->
        <p class="ms-2 small text-muted" *ngIf="newInvoice.healthcare_invoice === true">{{ newInvoice.document_type }} - {{ getDocumentTypeName(newInvoice.document_type!) }} (prestazione sanitaria){{ newInvoice.p_a ? ' PA' : '' }}</p>

        <div class="d-flex justify-content-between align-items-center ms-2 me-0 mb-2">
          <span>Segna come già incassata</span>
          <span>
            <mat-slide-toggle
              [(ngModel)]="newInvoice.is_paid"
              name="is_paid"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onPaidToggleChange($event)"
              matTooltip="Segna la fattura come già incassata."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
            </mat-slide-toggle>
          </span>
        </div>

        <div class="d-flex justify-content-between align-items-center ms-2 me-0 mb-2">
          <span>Fattura solo cartacea</span>
          <span>
            <mat-slide-toggle
              [(ngModel)]="newInvoice.paper_invoice"
              name="paper_invoice"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onPaperInvoiceToggleChange($event)"
              matTooltip="Se attivi questa opzione, la fattura non verrà emessa come fattura elettronica, ma solo come cartacea."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
            </mat-slide-toggle>
          </span>
        </div>

        <!-- Totale prestazioni -->
        <div class="d-flex justify-content-between align-items-center m-2">
          <span>Totale prestazioni ({{ numero_articoli }} articoli):</span>
          <span class="fw-medium">{{formatCardAmount(invoice_gross_amount) }}</span>
        </div>

        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center m-2">
          <span class="fw-medium"> Sconto:</span>
          <span class="fw-medium">- {{ formatCardAmount(invoice_discount_amount) }}</span>
        </div>

        <!-- Marca da bollo -->
        <div *ngIf="revenueStampOption === 'customer'">
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Marca da bollo:</span>
            <span>+{{ formatCardAmount(invoice_revenue_stamp) }}</span>
          </div>
        </div>
        <div *ngIf="invoice_revenue_stamp_on_user">
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Marca da bollo:</span>
            <!-- overwrite revenue stamp only visually -->
            <span>+{{ formatCardAmount(2) }}</span>
          </div>
        </div>

        <!-- Competenze -->
        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center m-2">
          <span class="fw-medium">Competenze:</span>
          <span class="fw-medium">{{ formatCardAmount((invoice_total_amount + invoice_revenue_stamp)) }}</span>
        </div>

        <!-- Rivalsa -->
        <div *ngIf="hasTaxWithholdingsOfKind('RIVALSA')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Rivalsa:</span>
            <span>{{ formatCardAmount(rivalsa_total) }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center ms-2 me-2">
            <span class="small text-muted">Totale con rivalsa:</span>
            <span class="small text-muted">{{ formatCardAmount(invoice_total_amount_with_rivalsa) }}</span>
          </div>
        </div>

        <!-- Cassa -->
        <div *ngIf="hasTaxWithholdingsOfKind('CASSA')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Cassa:</span>
            <span>{{ formatCardAmount(cassa_total) }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center ms-2 me-2">
            <span class="small text-muted">Imponibile:</span>
            <span class="small text-muted">{{ formatCardAmount(total_taxable) }}</span>
          </div>
        </div>

        <!-- IVA -->
        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center m-2">
          <span>IVA:</span>
          <span>{{ formatCardAmount(invoice_iva_amount) }}</span>
        </div>

        <!-- Ritenuta d'acconto -->
        <div *ngIf="hasTaxWithholdingsOfKind('RITENUTA_ACCONTO')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Ritenuta d'acconto:</span>
            <span>-{{ formatCardAmount(ritenuta_acconto_total) }}</span>
          </div>
        </div>

        <!-- Ritenute -->
        <div *ngIf="hasTaxWithholdingsOfKind('RITENUTA')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Ritenute:</span>
            <span>-{{ formatCardAmount(ritenuta_total) }}</span>
          </div>
        </div>

        <!-- Totale da incassare -->
        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center summary-item total">
          <span class="fw-bold h5 mt-2 ms-1">Totale da incassare:</span>
          <span class="fw-bold h5 mt-2 me-1">{{ formatCardAmount(invoice_total_paid_amount) }}</span>
        </div>

        <div class="d-flex align-self-end hidden-mobile">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            [disabled]="!invoiceForm.valid || numero_articoli === 0 || newInvoice.company_id === 0 "
            class="mt-3 me-3 custom-button-border"
            (click)="addNewElement(undefined, true)"
            matTooltip="Visualizza l'anteprima della fattura."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            <mat-icon>visibility</mat-icon>
            Anteprima
          </button>
          <button
            mat-stroked-button
            color="primary"
            type="button"
            [disabled]="!invoiceForm.valid || numero_articoli === 0 || newInvoice.company_id === 0 "
            class="mt-3 me-3 custom-button-border"
            (click)="saveDraftElement()"
            matTooltip="Le bozze salvate non vengono nè emsse nè inviate direttamente all'Agenzia delle Entrate. Potrai farlo in seguito dalla sezione 'Bozze salvate'."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            <mat-icon>save</mat-icon>
            Salva bozza
          </button>
          <button
            mat-raised-button
            matButton="filled"
            type="button"
            [disabled]="!invoiceForm.valid || numero_articoli === 0 || newInvoice.company_id === 0 "
            class="mt-3 me-0 primary-button custom-button-border"
            (click)="addNewElement()"
            matTooltip="Genera la fattura ed inoltra all'Agenzia delle Entrate."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            <mat-icon>send</mat-icon>
            Invia
          </button>
        </div>
        <!-- mobile version -->
        <div class="d-flex visible-mobile mt-2">
          <div class="container-fluid p-0">
            <!-- First row with Preview and Save buttons -->
            <div class="row g-2 mb-2">
              <div class="col-6">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  [disabled]="!invoiceForm.valid || numero_articoli === 0 || newInvoice.company_id === 0"
                  class="w-100 mt-3 me-3 custom-button-border"
                  (click)="addNewElement(undefined, true)"
                  matTooltip="Visualizza l'anteprima fattura."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <mat-icon>visibility</mat-icon>
                  Anteprima
                </button>
              </div>
              <div class="col-6">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  [disabled]="!invoiceForm.valid || numero_articoli === 0 || newInvoice.company_id === 0"
                  class="w-100 mt-3 me-3 custom-button-border"
                  (click)="saveDraftElement()"
                  matTooltip="Le bozze salvate non vengono nè emsse nè inviate direttamente all'Agenzia delle Entrate. Potrai farlo in seguito dalla sezione 'Bozze salvate'."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <mat-icon>save</mat-icon>
                  Salva bozza
                </button>
              </div>
            </div>
            
            <!-- Second row with Send button -->
            <div class="row g-2">

              <div class="col-12">
                <button
                  mat-raised-button
                  matButton="filled"
                  type="button"
                  [disabled]="!invoiceForm.valid || numero_articoli === 0 || newInvoice.company_id === 0"
                  class="w-100 mt-2 me-3 primary-button custom-button-border"
                  (click)="addNewElement()"
                  matTooltip="Genera la fattura ed inoltra all'Agenzia delle Entrate."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <mat-icon>send</mat-icon>
                  Invia
                </button>
              </div>
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  </form>
</div>

<div class="pt-3 mb-3"></div>

<!-- <button
  mat-raised-button
  color="primary"
  class="mt-3"
  (click)="generateAndUpload(114)"
>
  Save
</button> -->
